// import { useEffect, useState, useCallback } from "react";
// import axios from "axios";
// import { toast } from "sonner";
// import { useGlobalContext } from "../../GlobalContext";

// export default function useDrivers() {
//   const { baseurl, token, accessToken, AdminId, setIsUnauthorised } =
//     useGlobalContext();

//   const [teams, setTeams] = useState([]);
//   const [teamsLoading, setTeamsLoading] = useState(false);

//   const [drivers, setDrivers] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [chargeRows, setChargeRows] = useState([]);
//   const [chargesLoading, setChargesLoading] = useState(false);

//   const [configRows, setConfigRows] = useState([]);
//   const [configLoading, setConfigLoading] = useState(false);

//   /* ================= TEAMS ================= */

//   const fetchDriverTeams = useCallback(async () => {
//     if (!AdminId) return;
//     setTeamsLoading(true);
//     try {
//       const res = await axios.post(
//         `${baseurl}/api/Driver/v2.0/getDriverTeamList`,
//         { userid: "", adminId: String(AdminId) },
//         { headers: { Authorization: `Basic ${token}` } }
//       );

//       if (res.data.responseCode === "00") {
//         setTeams(res.data.data || []);
//       } else if (res.data.responseCode === "401") {
//         setIsUnauthorised(true);
//       } else {
//         toast.error(res.data.responseMessage);
//       }
//     } catch {
//       toast.error("Failed to fetch teams");
//     } finally {
//       setTeamsLoading(false);
//     }
//   }, [AdminId, baseurl, token, setIsUnauthorised]);

//   /* ================= DRIVER LIST ================= */

//   const fetchDrivers = useCallback(
//     async (silent = false) => {
//       if (!silent) setLoading(true);

//       try {
//         const res = await axios.post(
//           `${baseurl}/api/Driver/v1.0/getDriverList`,
//           { userid: "", adminId: AdminId },
//           { headers: { Authorization: `Basic ${token}` } }
//         );

//         if (res.data.responseCode === "00") {
//           setDrivers(res.data.data || []);
//         } else if (res.data.responseCode === "401") {
//           setIsUnauthorised(true);
//         } else {
//           toast.error(res.data.responseMessage || "Failed to fetch drivers");
//         }
//       } catch (err) {
//         toast.error("Error fetching drivers");
//         console.error(err);
//       } finally {
//         if (!silent) setLoading(false);
//       }
//     },
//     [baseurl, token, AdminId, setIsUnauthorised]
//   );

//   /* ================= DELETE DRIVER ================= */

//   const deleteDriver = async (driverId) => {
//     try {
//       const res = await axios.post(
//         `${baseurl}/api/Driver/v1.0/deleteDriver`,
//         { driverId, adminId: AdminId },
//         { headers: { Authorization: `Bearer ${accessToken}` } }
//       );

//       if (res.data.responseCode === "00") {
//         toast.success(res.data.responseMessage);
//         setDrivers((prev) => prev.filter((d) => d.driverId !== driverId));
//       } else if (res.data.responseCode === "401") {
//         setIsUnauthorised(true);
//       } else {
//         toast.error(res.data.responseMessage || "Delete failed");
//       }
//     } catch {
//       toast.error("Error deleting driver");
//     }
//   };

//   /* ================= DUTY TOGGLE ================= */

//   const toggleDutyStatus = async (driver, isOnDuty) => {
//     const nextStatus = isOnDuty ? "off_duty" : "on_duty";

//     setDrivers((prev) =>
//       prev.map((d) =>
//         d.driverId === driver.driverId
//           ? { ...d, dutyStatus: nextStatus }
//           : d
//       )
//     );

//     try {
//       const payload = {
//         device: "Admin",
//         userId: "",
//         driverId: driver.driverId,
//         dutyValue: nextStatus,
//         adminId: AdminId,
//       };

//       const res = await axios.post(
//         `${baseurl}/api/User/v1.0/updateDriverDutyTime`,
//         payload,
//         { headers: { Authorization: `Basic ${token}` } }
//       );

//       if (res.data.responseCode === "00") {
//         toast.success("Duty status updated");
//         fetchDrivers(true);
//       } else if (res.data.responseCode === "401") {
//         setIsUnauthorised(true);
//       } else {
//         toast.error(res.data.responseMessage);
//       }
//     } catch {
//       toast.error("Error updating duty status");
//     }
//   };

//   /* ================= CREATE DRIVER ================= */

//   const createDriverApi = async (payload, onSuccess) => {
//     try {
//       const res = await axios.post(
//         `${baseurl}/api/Driver/v1.0/createDriver`,
//         payload,
//         { headers: { Authorization: `Basic ${token}` } }
//       );

//       if (res.data.responseCode === "00") {
//         toast.success(res.data.responseMessage);
//         onSuccess?.();
//         fetchDrivers(true);
//       } else if (res.data.responseCode === "401") {
//         setIsUnauthorised(true);
//       } else {
//         toast.error(res.data.responseMessage);
//       }
//     } catch {
//       toast.error("Error Adding the driver");
//     }
//   };

//   /* ================= NOTIFICATIONS ================= */

//   const sendBulkNotificationApi = async (payload, setSending) => {
//     try {
//       setSending(true);

//       const res = await axios.post(
//         `${baseurl}/api/User/v1.0/sendNotification`,
//         payload,
//         { headers: { Authorization: `Basic ${token}` } }
//       );

//       if (res.data.responseCode === "00") {
//         toast.success(
//           `Notification sent to ${payload.driverId.length} driver(s).`
//         );
//         return true;
//       }

//       if (res.data.responseCode === "401") {
//         setIsUnauthorised(true);
//         return false;
//       }

//       toast.error(res.data.responseMessage || "Failed to send notification");
//       return false;
//     } catch {
//       toast.error("Error sending notifications");
//       return false;
//     } finally {
//       setSending(false);
//     }
//   };

//   const sendSingleNotificationApi = async (payload, setSending) => {
//     try {
//       setSending(true);

//       const res = await axios.post(
//         `${baseurl}/api/User/v1.0/sendNotification`,
//         payload,
//         { headers: { Authorization: `Basic ${token}` } }
//       );

//       if (res.data.responseCode === "00") {
//         toast.success("Notification sent!");
//         return true;
//       }

//       if (res.data.responseCode === "401") {
//         setIsUnauthorised(true);
//         return false;
//       }

//       toast.error(res.data.responseMessage || "Failed to send notification");
//       return false;
//     } catch {
//       toast.error("Error sending notification");
//       return false;
//     } finally {
//       setSending(false);
//     }
//   };

//   /* ================= DRIVER CONFIG ================= */

//   const fetchAllDriverConfigs = useCallback(
//     async (silent = false) => {
//       if (!silent) setConfigLoading(true);

//       try {
//         const res = await axios.post(
//           `${baseurl}/api/Driver/v1.0/getAllDriverConfigDetails`,
//           { adminId: AdminId, driverCode: "" },
//           { headers: { Authorization: `Basic ${token}` } }
//         );

//         if (res.data.responseCode === "00") {
//           setConfigRows(res.data.data || []);
//         } else if (res.data.responseCode === "401") {
//           setIsUnauthorised(true);
//         } else {
//           toast.error(res.data.responseMessage || "Failed to fetch configs");
//         }
//       } catch {
//         toast.error("Error fetching driver configurations");
//       } finally {
//         if (!silent) setConfigLoading(false);
//       }
//     },
//     [baseurl, token, AdminId, setIsUnauthorised]
//   );

//   const handleDeleteConfig = async (configId) => {
//     const ok = window.confirm("Are you sure you want to delete this config?");
//     if (!ok) return;

//     try {
//       const res = await axios.post(
//         `${baseurl}/api/Driver/v1.0/deleteDriverConfigDetails`,
//         { adminId: AdminId, configId: String(configId) },
//         { headers: { Authorization: `Basic ${token}` } }
//       );

//       if (res.data.responseCode === "00") {
//         toast.success(res.data.responseMessage || "Deleted");
//         fetchAllDriverConfigs(true);
//       } else if (res.data.responseCode === "401") {
//         setIsUnauthorised(true);
//       } else {
//         toast.error(res.data.responseMessage || "Delete failed");
//       }
//     } catch {
//       toast.error("Error deleting config");
//     }
//   };

//   /* ================= INIT ================= */

//   useEffect(() => {
//     if (AdminId) fetchDrivers();
//   }, [AdminId, fetchDrivers]);

//   return {
//     drivers,
//     loading,
//     fetchDrivers,
//     deleteDriver,
//     toggleDutyStatus,
//     createDriverApi,

//     teams,
//     teamsLoading,
//     fetchDriverTeams,

//     sendBulkNotificationApi,
//     sendSingleNotificationApi,

//     configRows,
//     configLoading,
//     fetchAllDriverConfigs,
//     handleDeleteConfig,
//   };
// }

import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";
import imageCompression from "browser-image-compression";

export default function useDrivers() {
  const { baseurl, token, accessToken, AdminId, setIsUnauthorised } =
    useGlobalContext();

  const [teams, setTeams] = useState([]);
  const [teamsLoading, setTeamsLoading] = useState(false);

  const [drivers, setDrivers] = useState([]);
  const [kycDrivers, setKycDrivers] = useState([]);
  const [driverKycStatus, setDriverKycStatus] = useState(null);

  const [loading, setLoading] = useState(false);
  const [kycStatusLoading, setKycStatusLoading] = useState(false);

  const [chargeRows, setChargeRows] = useState([]);
  const [chargesLoading, setChargesLoading] = useState(false);

  const [kycSubmitting, setKycSubmitting] = useState(false);

  const [configRows, setConfigRows] = useState([]);
  const [configLoading, setConfigLoading] = useState(false);

  // fetch team

const fetchDriverTeams = useCallback(async () => {

  setTeamsLoading(true);
  try {
    const res = await axios.post(
      `${baseurl}/api/Driver/v2.0/getDriverTeamList`,
      { userid: "", adminId: String(AdminId) },
      { headers: { Authorization: `Basic ${token}` } }
    );

    if (res.data.responseCode === "00") {
      setTeams(res.data.data || []);
    } 
    else if (res.data.responseCode === "401") {
      setIsUnauthorised(true);
    } 
    else {
      toast.error(res.data.responseMessage);
    }
  } catch (e) {
    console.error("Team API error:", e);
    toast.error("Failed to fetch teams");
  } finally {
    setTeamsLoading(false);
  }
}, [baseurl, token, AdminId, setIsUnauthorised]);

  /*  DRIVER LIST */

  const fetchDrivers = useCallback(
  async (silent = false) => {
    if (!silent) setLoading(true);

    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/getDriverList`,
        { userid: "", adminId: AdminId },
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (res.data.responseCode === "00") {
        const list = res.data.data || [];
        setDrivers(list);
        return list;   // ✅ VERY IMPORTANT
      }

      if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage || "Failed to fetch drivers");
      }

      return []; // fallback
    } catch (err) {
      console.error(err);
      toast.error("Error fetching drivers");
      return [];
    } finally {
      if (!silent) setLoading(false);
    }
  },
  [baseurl, token, AdminId, setIsUnauthorised]
);

  /*  KYC LIST */

  const fetchDriverKycDetails = useCallback(
    async (preserveLocalUpdates = true) => {
      setLoading(true);

      try {
        const res = await axios.post(
          `${baseurl}/api/Driver/v1.0/getAllDriverKycDetails`,
          { userid: "", adminId: AdminId },
          { headers: { Authorization: `Basic ${token}` } },
        );

        if (res.data.responseCode === "00") {
          const serverData = res.data.data || [];

          if (preserveLocalUpdates) {
            setKycDrivers((prev) =>
              serverData.map((serverDriver) => {
                const local = prev.find(
                  (d) =>
                    d.id === serverDriver.id ||
                    d.driver_code === serverDriver.driver_code,
                );

                if (
                  local &&
                  ["Approved", "Rejected"].includes(local.status) &&
                  serverDriver.status === "Pending"
                ) {
                  return { ...serverDriver, status: local.status };
                }

                return serverDriver;
              }),
            );
          } else {
            setKycDrivers(serverData);
          }
        } else if (res.data.responseCode === "401") {
          setIsUnauthorised(true);
        } else {
          toast.error(res.data.responseMessage);
        }
      } catch (err) {
        toast.error("Error fetching Driver KYC details");
        console.error(err);
      } finally {
        setLoading(false);
      }
    },
    [baseurl, token, AdminId, setIsUnauthorised],
  );

  /*  VIEW / UPDATE KYC  */

  const handleKycAction = async (kycId, action = "view", status = "") => {
    setKycStatusLoading(true);

    try {
      const payload = {
        kycId: kycId.toString(),
        kycStatus: action === "view" ? "" : status,
        adminId: AdminId,
      };

      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/verifyDriverkycDetails`,
        payload,
        { headers: { Authorization: `Basic ${token}` } },
      );

      if (res.data.responseCode === "00") {
        return action === "view"
          ? res.data.data
          : { success: true, message: res.data.responseMessage };
      }

      if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      }

      throw new Error(res.data.responseMessage || "KYC action failed");
    } catch (err) {
      toast.error(err.message || "KYC action failed");
      throw err;
    } finally {
      setKycStatusLoading(false);
    }
  };

  /*  DELETE DRIVER  */

  const deleteDriver = async (driverId) => {
    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/deleteDriver`,
        { driverId, adminId: AdminId },
        { headers: { Authorization: `Bearer ${accessToken}` } },
      );

      if (res.data.responseCode === "00") {
        toast.success(res.data.responseMessage);
        setDrivers((prev) => prev.filter((d) => d.driverId !== driverId));
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage || "Delete failed");
      }
    } catch {
      toast.error("Error deleting driver");
    }
  };

  /*  DUTY TOGGLE  */

  const toggleDutyStatus = async (driver, isOnDuty) => {
    const nextStatus = isOnDuty ? "off_duty" : "on_duty";

    setDrivers((prev) =>
      prev.map((d) =>
        d.driverId === driver.driverId ? { ...d, dutyStatus: nextStatus } : d,
      ),
    );

    try {
      const payload = {
        device: "Admin",
        userId: "",
        driverId: driver.driverId,
        dutyValue: nextStatus,
        adminId: AdminId,
      };

      const res = await axios.post(
        `${baseurl}/api/User/v1.0/updateDriverDutyTime`,
        payload,
        { headers: { Authorization: `Basic ${token}` } },
      );

      if (res.data.responseCode === "00") {
        toast.success("Duty status updated");
        fetchDrivers(true);
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage);
      }
    } catch {
      toast.error("Error updating duty status");
    }
  };

  // driver charge

  const fetchDriverCharges = useCallback(
    async (silent = false) => {
      if (!silent) setChargesLoading(true);

      try {
        const res = await axios.post(
          `${baseurl}/api/Transactions/v1.0/getDriverCharges`,
          { driverCode: "" },
          { headers: { Authorization: `Basic ${token}` } },
        );

        if (res.data.responseCode === "00") {
          const normalized = (res.data.data || []).map((g) => {
            const d = drivers.find((x) => x.driverId === g.driverCode);
            const charges = g.charges || [];

            return {
              driverCode: g.driverCode,
              name: d?.fullName || d?.username || "",
              teamName: d?.teamName || "",
              per_day: charges.find((c) => c.type === "per_day") || null,
              per_order: charges.find((c) => c.type === "per_order") || null,
            };
          });

          setChargeRows(normalized);
        } else if (res.data.responseCode === "401") {
          setIsUnauthorised(true);
        } else {
          toast.error(res.data.responseMessage || "Failed to fetch charges");
        }
      } catch {
        toast.error("Error fetching driver charges");
      } finally {
        if (!silent) setChargesLoading(false);
      }
    },
    [baseurl, token, drivers, setIsUnauthorised],
  );

  /*  CREATE DRIVER  */

  const createDriverApi = async (payload, onSuccess) => {
    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/createDriver`,
        payload,
        { headers: { Authorization: `Basic ${token}` } },
      );

      if (res.data.responseCode === "00") {
        toast.success(res.data.responseMessage);
        onSuccess?.();
        fetchDrivers(true);
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage);
      }
    } catch {
      toast.error("Error Adding the driver");
    }
  };

  /* ================= BULK NOTIFICATION ================= */

  const sendBulkNotificationApi = async (payload, setSending) => {
    try {
      setSending(true);

      const res = await axios.post(
        `${baseurl}/api/User/v1.0/sendNotification`,
        payload,
        { headers: { Authorization: `Basic ${token}` } },
      );

      if (res.data.responseCode === "00") {
        toast.success(
          `Notification sent to ${payload.driverId.length} driver(s).`,
        );
        return true;
      }

      if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
        return false;
      }

      toast.error(res.data.responseMessage || "Failed to send notification");
      return false;
    } catch {
      toast.error("Error sending notifications");
      return false;
    } finally {
      setSending(false);
    }
  };

  /* ================= DRIVER CHARGES APIs ================= */

  const fetchChargesForDriverApi = async (
    driverCode,
    setExisting,
    setLoading,
  ) => {
    if (!driverCode) return;

    setLoading(true);
    try {
      const res = await axios.post(
        `${baseurl}/api/Transactions/v1.0/getDriverCharges`,
        { driverCode },
        { headers: { Authorization: `Basic ${token}` } },
      );

      if (res.data.responseCode === "00") {
        const group = (res.data.data || [])[0];
        const charges = group?.charges || [];

        const perDay = charges.find((c) => c.type === "per_day") || null;
        const perOrder = charges.find((c) => c.type === "per_order") || null;

        setExisting({
          per_day: {
            id: perDay?.id ?? null,
            amount: perDay?.amount?.toString?.() ?? "",
          },
          per_order: {
            id: perOrder?.id ?? null,
            amount: perOrder?.amount?.toString?.() ?? "",
          },
        });
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage || "Failed to fetch charges");
      }
    } catch {
      toast.error("Error fetching driver charges");
    } finally {
      setLoading(false);
    }
  };

  const saveDriverChargeApi = async ({
    adminId,
    driverCode,
    type,
    id,
    amount,
  }) => {
    if (!amount && amount !== 0) return null; // skip empty

    const isUpdate = !!id;

    const payload = isUpdate
      ? {
          adminId,
          id: String(id),
          type,
          amount: String(amount),
        }
      : {
          adminId,
          driverCode,
          type,
          amount: String(amount),
        };

    const url = isUpdate
      ? `${baseurl}/api/Transactions/v1.0/updateDriverCharges`
      : `${baseurl}/api/Transactions/v1.0/addDriverCharges`;

    return axios.post(url, payload, {
      headers: { Authorization: `Basic ${token}` },
    });
  };

  /*  KYC IMAGE COMPRESSION  */

  const compressImageMax = async (file) => {
    try {
      const options = {
        maxSizeMB: 0.1,
        maxWidthOrHeight: 600,
        useWebWorker: true,
        fileType: "image/jpeg",
        quality: 0.7,
        initialQuality: 0.7,
      };

      const compressedFile = await imageCompression(file, options);

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          let base64 = reader.result;
          base64 = base64.replace(
            /^data:image\/(jpeg|png|webp|jpg);base64,/,
            "",
          );
          resolve(base64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(compressedFile);
      });
    } catch (err) {
      console.error("Image compression failed", err);
      throw err;
    }
  };

  /*  UPLOAD KYC IMAGE  */

  const uploadImageToServer = async (imageFile, driverCode, imageType) => {
    // already uploaded URL
    if (typeof imageFile === "string") return imageFile;

    try {
      const compressedBase64 = await compressImageMax(imageFile);

      const payload = {
        userid: driverCode,
        item_name: `${driverCode}_${imageType}`,
        image_data: compressedBase64,
        type: imageType,
        adminId: AdminId,
      };

      const res = await axios.post(
        "https://bumppy.in/packky/api/v1/uploadKycImage.php",
        payload,
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (res.data && (res.data.status === "0" || res.data.status === 0)) {
        return (
          res.data.image_url ||
          `${baseurl}/uploads/kyc/${driverCode}_${imageType}.jpg`
        );
      }

      throw new Error(res.data?.msg || "Image upload failed");
    } catch (err) {
      console.error(`Upload failed for ${imageType}`, err);
      throw err;
    }
  };

  /*  SUBMIT KYC STEP  */

  const handleStepSubmit = async (stepNumber, stepData) => {
    try {
      setKycSubmitting(true);

      const payload = {
        userid: stepData.driver_code,
        adminId: AdminId,
        step: stepNumber.toString(),
        ...stepData,
      };

      const res = await axios.post(
        `${baseurl}/api/Driver/v2.0/addDriverKYCDetails`,
        payload,
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (res.data.responseCode === "00") {
        toast.success(`Step ${stepNumber} saved successfully`);
        return true;
      }

      toast.error(res.data.responseMessage || "Failed to save step");
      return false;
    } catch (err) {
      console.error("KYC step submit error", err);
      toast.error("Error saving KYC data");
      return false;
    } finally {
      setKycSubmitting(false);
    }
  };

  // driver config

  const fetchAllDriverConfigs = useCallback(
    async (silent = false) => {
      if (!silent) setConfigLoading(true);

      try {
        const res = await axios.post(
          `${baseurl}/api/Driver/v1.0/`,
          { adminId: AdminId, driverCode: "" },
          { headers: { Authorization: `Basic ${token}` } },
        );

        if (res.data.responseCode === "00") {
          setConfigRows(res.data.data || []);
        } else if (res.data.responseCode === "401") {
          setIsUnauthorised(true);
        } else {
          toast.error(res.data.responseMessage || "Failed to fetch configs");
        }
      } catch {
        toast.error("Error fetching driver configurations");
      } finally {
        if (!silent) setConfigLoading(false);
      }
    },
    [baseurl, token, AdminId, setIsUnauthorised],
  );

  // delete config

  const handleDeleteConfig = async (configId) => {
    const ok = window.confirm("Are you sure you want to delete this config?");
    if (!ok) return;

    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/deleteDriverConfigDetails`,
        { adminId: AdminId, configId: String(configId) },
        { headers: { Authorization: `Basic ${token}` } },
      );

      if (res.data.responseCode === "00") {
        toast.success(res.data.responseMessage || "Deleted");
        fetchAllDriverConfigs(true);
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage || "Delete failed");
      }
    } catch {
      toast.error("Error deleting config");
    }
  };

  /* ================= SINGLE DRIVER NOTIFICATION ================= */

  const sendSingleNotificationApi = async (payload, setSending) => {
    try {
      setSending(true);

      const res = await axios.post(
        `${baseurl}/api/User/v1.0/sendNotification`,
        payload,
        { headers: { Authorization: `Basic ${token}` } },
      );

      if (res.data.responseCode === "00") {
        toast.success("Notification sent!");
        return true;
      }

      if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
        return false;
      }

      toast.error(res.data.responseMessage || "Failed to send notification");
      return false;
    } catch {
      toast.error("Error sending notification");
      return false;
    } finally {
      setSending(false);
    }
  };

  /* ================= EDIT DRIVER ================= */

  const editDriverApi = async (payload) => {
    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/editDriver`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );

      if (res.data.responseCode === "00") {
        toast.success("Driver updated successfully");
        fetchDrivers(true); // refresh list silently
        return true;
      }

      if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
        return false;
      }

      toast.error(res.data.responseMessage || "Failed to update driver");
      return false;
    } catch (err) {
      toast.error("Error occurred while updating driver");
      return false;
    }
  };

  /* ================= UPDATE DUTY TYPE ================= */

  const updateDriverDutyApi = async (payload) => {
    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/updateDriverDutyType`,
        payload,
        { headers: { Authorization: `Basic ${token}` } },
      );

      if (res.data.responseCode === "00") {
        toast.success("Driver duty time updated successfully!");
        fetchDrivers(true);
        return true;
      }

      if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
        return false;
      }

      toast.error(
        res.data.responseMessage || "Failed to update driver duty time",
      );
      return false;
    } catch {
      toast.error("Error occur while updating driver duty time");
      return false;
    }
  };

  /* ================= DRIVER CONFIG (DETAIL VIEW) ================= */

  const fetchDriverConfigByCode = async (
    driverCode,
    setFetching,
    setConfig,
  ) => {
    if (!driverCode) return;

    setFetching(true);
    try {
      const payload = { adminId: AdminId, driverCode };

      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/getAllDriverConfigDetails`,
        payload,
        { headers: { Authorization: `Basic ${token}` } },
      );

      if (res.data.responseCode === "00") {
        const row =
          (res.data.data || []).find((x) => x.driver_code === driverCode) ||
          null;
        setConfig(row);
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage || "Failed to fetch config");
      }
    } catch {
      toast.error("Error fetching config");
    } finally {
      setFetching(false);
    }
  };

  /* ================= DRIVER CONFIG (QUICK ADD) ================= */

  const fetchDriverConfigForQuickAdd = async (
    driverCode,
    setFetching,
    setExistingConfig,
    setForm,
  ) => {
    if (!driverCode) return;

    setFetching(true);
    try {
      const payload = { adminId: AdminId, driverCode };

      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/getAllDriverConfigDetails`,
        payload,
        { headers: { Authorization: `Basic ${token}` } },
      );

      if (res.data.responseCode === "00") {
        const row =
          (res.data.data || []).find((x) => x.driver_code === driverCode) ||
          null;

        setExistingConfig(row);

        if (row) {
          setForm({
            cashLimit: row.cash_limit?.toString?.() ?? "",
            dailyTaskLimit: row.daily_task_limit?.toString?.() ?? "",
            concurrentOrder: row.concurrent_order?.toString?.() ?? "",
            maxTeamLimit: row.max_team_limit?.toString?.() ?? "",
          });
        } else {
          setForm({
            cashLimit: "",
            dailyTaskLimit: "",
            concurrentOrder: "",
            maxTeamLimit: "",
          });
        }
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(
          res.data.responseMessage || "Failed to fetch existing config",
        );
      }
    } catch {
      toast.error("Error fetching existing config");
    } finally {
      setFetching(false);
    }
  };

  const saveDriverQuickConfig = async (payload) => {
    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/insertDriverConfigDetails`,
        payload,
        { headers: { Authorization: `Basic ${token}` } },
      );

      if (res.data.responseCode === "00") {
        toast.success(res.data.responseMessage || "Saved");
        return true;
      }

      if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
        return false;
      }

      toast.error(res.data.responseMessage || "Failed to save");
      return false;
    } catch {
      toast.error("Error saving config");
      return false;
    }
  };

  const deleteDriverQuickConfig = async (configId) => {
    try {
      const payload = { adminId: AdminId, configId: String(configId) };

      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/deleteDriverConfigDetails`,
        payload,
        { headers: { Authorization: `Basic ${token}` } },
      );

      if (res.data.responseCode === "00") {
        toast.success(res.data.responseMessage || "Deleted");
        return true;
      }

      if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
        return false;
      }

      toast.error(res.data.responseMessage || "Failed to delete");
      return false;
    } catch {
      toast.error("Error deleting config");
      return false;
    }
  };

  /* =============== DRIVER CONFIG (SINGLE DRIVER MODAL) =============== */

  const fetchSingleDriverConfig = async (
    driverCode,
    setFetching,
    setExistingConfig,
    setForm,
  ) => {
    if (!driverCode) return;

    setFetching(true);
    try {
      const payload = { adminId: AdminId, driverCode };

      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/getAllDriverConfigDetails`,
        payload,
        { headers: { Authorization: `Basic ${token}` } },
      );

      if (res.data.responseCode === "00") {
        const row =
          (res.data.data || []).find((x) => x.driver_code === driverCode) ||
          null;

        setExistingConfig(row);

        if (row) {
          setForm({
            cashLimit: row.cash_limit?.toString?.() ?? "",
            dailyTaskLimit: row.daily_task_limit?.toString?.() ?? "",
            concurrentOrder: row.concurrent_order?.toString?.() ?? "",
            maxTeamLimit: row.max_team_limit?.toString?.() ?? "",
          });
        } else {
          setForm({
            cashLimit: "",
            dailyTaskLimit: "",
            concurrentOrder: "",
            maxTeamLimit: "",
          });
        }
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage || "Failed to fetch config");
      }
    } catch {
      toast.error("Error fetching driver config");
    } finally {
      setFetching(false);
    }
  };

  const saveSingleDriverConfig = async (payload) => {
    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/insertDriverConfigDetails`,
        payload,
        { headers: { Authorization: `Basic ${token}` } },
      );

      if (res.data.responseCode === "00") {
        toast.success(res.data.responseMessage || "Saved");
        return true;
      }

      if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
        return false;
      }

      toast.error(res.data.responseMessage || "Failed to save config");
      return false;
    } catch {
      toast.error("Error saving config");
      return false;
    }
  };

  const deleteSingleDriverConfig = async (configId) => {
    try {
      const payload = { adminId: AdminId, configId: String(configId) };

      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/deleteDriverConfigDetails`,
        payload,
        { headers: { Authorization: `Basic ${token}` } },
      );

      if (res.data.responseCode === "00") {
        toast.success(res.data.responseMessage || "Deleted");
        return true;
      }

      if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
        return false;
      }

      toast.error(res.data.responseMessage || "Failed to delete");
      return false;
    } catch {
      toast.error("Error deleting config");
      return false;
    }
  };

  /*  RETURN  */

  return {
    // drivers
    drivers,
    loading,
    fetchDrivers,
    deleteDriver,
    toggleDutyStatus,
    createDriverApi,

    // teams
    teams,
    teamsLoading,
    fetchDriverTeams,
    sendBulkNotificationApi,

    // kyc
    kycDrivers,
    driverKycStatus,
    kycStatusLoading,
    fetchDriverKycDetails,
    handleKycAction,

    //  kyc form helpers
    compressImageMax,
    uploadImageToServer,
    handleStepSubmit,
    kycSubmitting,

    // driver charges
    chargeRows,
    chargesLoading,
    fetchDriverCharges,

    //  configs
    configRows,
    configLoading,
    fetchAllDriverConfigs,
    handleDeleteConfig,

    // driver charge
    fetchChargesForDriverApi,
    saveDriverChargeApi,
    sendBulkNotificationApi,
    sendSingleNotificationApi,

    editDriverApi,
    updateDriverDutyApi,
    fetchDriverConfigByCode,

    fetchDriverConfigForQuickAdd,
    saveDriverQuickConfig,
    deleteDriverQuickConfig,

    fetchSingleDriverConfig,
    saveSingleDriverConfig,
    deleteSingleDriverConfig,
  };
}
